import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { OverlayModule } from '@angular/cdk/overlay';
import { StoreModule } from '@ngrx/store';

import * as Api from './store/apis';
import * as Service from './services';
import { CoreRoute } from './route';
import { metaReducers, reducers } from './store/reducers';

import { ModalModule } from 'shared/modal/module';

import { ApiResourceInterceptor } from 'services/http/resource';
import { ShareRequestInterceptor } from 'services/http/share';
import { TimeoutInterceptor } from 'services/http/timeout';
import { GenericErrorInterceptor } from 'services/http/generic-error';
import { CmsErrorInterceptor } from 'services/http/cms-error';

/**
 * We need to create listeners before UI Router is initialized so hooks (ex. onBefore, onStart) work immediately without delay
 *
 * Router initialization happens in the `initializeRouter` function below.
*/
export function initRouterListeners(coreRoute: CoreRoute): () => void {
    return () => {
        coreRoute.setupRouterListener();
    };
}

@NgModule({
    imports: [
        HttpClientModule,
        StoreModule.forRoot(reducers, { 
            metaReducers,
            runtimeChecks: {
                // turning these off for now since they are blocking activation flow
                // TODO: will discuss how we can turn them back in the future
                strictStateImmutability: false,
                strictActionImmutability: false
            }
        }),
        ModalModule,
        OverlayModule
    ],
    providers: [
        Api.CmsApi,
        Api.EsimWebsheetApi,
        CoreRoute,
        {
            provide: ErrorHandler,
            useClass: Service.XmErrorHandler
        },

        {
            provide: APP_INITIALIZER,
            useFactory: initRouterListeners,
            deps: [ CoreRoute ],
            multi: true
        },
        { provide: HTTP_INTERCEPTORS, useClass: ApiResourceInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ShareRequestInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: GenericErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: CmsErrorInterceptor, multi: true }
    ]
})
export class CoreModule {}
